module.exports = __webpack_public_path__ + "static/media/ic_menu.3d986ffc.svg";